import { styled, Radio, RadioGroup } from '@mui/material';
import { CustomForm, CustomFromLabel } from 'widget/event_components/Ticket/elements';

export const ErrorMessage = styled('div')`
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;
`;

export const Form = CustomForm;
export const TermsForm = styled(CustomForm)`
  display: flex;
  align-items: center;
`;

export const Label = CustomFromLabel;

export const CustomRadio = styled(Radio)`
  width: 20px;
  height: 20px;
  margin-left: 12px;
`;

export const RadioWrapper = styled('div')`
  display: flex;
  width: 100%;
  gap: 12px;
`;

export const CustomRadioGroup = styled(RadioGroup)`
  gap: 12px;
`;
